import { twApi } from '../api';
import { Validation, ValidationPayload, ValidationsResponse } from './validationsHelper.model';

const validationsHelper = twApi.injectEndpoints({
  endpoints: (builder) => ({
    validateDispatch: builder.mutation<ValidationsResponse, { data: ValidationPayload }>({
      query: ({ data }) => ({
        url: 'validate/dispatch',
        method: 'POST',
        body: data
      }),
      transformResponse: (response: { message: string; data: Validation[] }) => {
        return { message: response.message, data: response.data };
      }
    })
  }),
  overrideExisting: false
});

export const { useValidateDispatchMutation } = validationsHelper;
